import { DictionaryModule, ServiceResponseModule } from '@sdbn/common';
import { RegisterEntranceCombinedComponent } from './component/register-entrance-combined/register-entrance-combined.component';
import { RegisterLeaveCombinedComponent } from './component/register-leave-combined/register-leave-combined.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QRCodeComponent } from 'angularx-qrcode';

import { DeleteTransportDialogComponent } from './component/delete-transport-dialog/delete-transport-dialog.component';
import { EndTransportPauseDialogComponent } from './component/end-transport-pause-dialog/end-transport-pause-dialog.component';
import { GcCaseDialogComponent } from './component/gc-case-dialog/gc-case-dialog.component';
import { StartTransportPauseDialogComponent } from './component/start-transport-pause-dialog/start-transport-pause-dialog.component';
import { TruckGcCaseDialogComponent } from './component/truck-gc-case-dialog/truck-gc-case-dialog.component';
import { TruckInfoPanelModule } from '../../common/truck-info-panel/truck-info-panel.module';
import { TransportInfoPanelModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { SupplementaryEquipmentHandoutComponent } from './component/supplementary-equipment-handout/supplementary-equipment-handout.component';
import { SupplementaryEquipmentTakeBackComponent } from './component/supplementary-equipment-take-back/supplementary-equipment-take-back.component';


@NgModule({
  declarations: [
    GcCaseDialogComponent,
    DeleteTransportDialogComponent,
    StartTransportPauseDialogComponent,
    EndTransportPauseDialogComponent,
    RegisterLeaveCombinedComponent,
    RegisterEntranceCombinedComponent,
    TruckGcCaseDialogComponent,
    SupplementaryEquipmentHandoutComponent,
    SupplementaryEquipmentTakeBackComponent,
  ],
  imports: [
    CommonModule,

    QRCodeComponent,
    FormsModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    TruckInfoPanelModule,
    DictionaryModule,
    CommonTranslationModule,
    ServiceResponseModule,
    ApplicationClientCommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatDialogModule,
    MatInputModule
  ],
  exports: [
    GcCaseDialogComponent,
    DeleteTransportDialogComponent,
    StartTransportPauseDialogComponent,
    EndTransportPauseDialogComponent,
    RegisterLeaveCombinedComponent,
    RegisterEntranceCombinedComponent,
    TruckGcCaseDialogComponent
  ]
})
export class VisitOverviewModule { }
